"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@osmosys/utils");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const Spinner_1 = require("../reusables/Spinner");
const index_1 = require("./Log/index");
const react_loops_1 = require("react-loops");
exports.OsmosysLogTerminalInner = props => {
    const { logs, status, showSpinner = true } = props;
    const container = react_1.default.useRef(null);
    const logGroups = logs
        ? utils_1.groupAdjacent(logs, (prev, cur) => !prev.parentTimestamp || prev.parentTimestamp !== cur.parentTimestamp)
        : [];
    return (react_1.default.createElement("div", { className: "text-monospace", ref: container },
        react_1.default.createElement(react_loops_1.For, { of: logGroups, as: childLogs => (react_1.default.createElement("div", { className: classnames_1.default('log-group my-3') },
                react_1.default.createElement(react_loops_1.For, { of: childLogs, as: (childLog, { index: childIndex }) => (react_1.default.createElement(index_1.OsmosysLogTerminalLog, { index: childIndex, log: childLog })) }))) }),
        status === 'notRunning' && react_1.default.createElement("p", null, "_"),
        showSpinner && status === 'loading' && react_1.default.createElement(Spinner_1.Spinner, null)));
};
// import { groupAdjacent } from '@osmosys/utils';
// import classnames from 'classnames';
// import React, { FC } from 'react';
// import { Spinner } from '../reusables/Spinner';
// import { Log } from './OsmosysLogTerminal/Log';
// import { ILog } from './OsmosysLogTerminal';
// import { For } from 'react-loops';
// export interface ILogTerminalProps {
//     logs: ILog[];
//     status?: 'notRunning' | 'error' | 'success' | 'loading';
//     showSpinner?: boolean;
//     run?: boolean;
// }
// export const LogTerminalInner: FC<ILogTerminalProps> = props => {
//     const { logs, status, showSpinner = true } = props;
//     const container = React.useRef<HTMLDivElement>(null);
//     const logGroups = logs
//         ? groupAdjacent<ILog>(
//             logs,
//             (prev: ILog, cur: ILog) =>
//                 !prev.parentTimestamp || prev.parentTimestamp !== cur.parentTimestamp
//         )
//         : ([] as ILog[][]);
//     return (
//         <div className="text-monospace" ref={container}>
//             <For
//                 of={logGroups}
//                 as={childLogs => (
//                     <div className={classnames('log-group my-3')}>
//                         <For
//                             of={childLogs}
//                             as={(childLog, { index: childIndex }) => (
//                                 <Log index={childIndex} log={childLog} />
//                             )}
//                         />
//                     </div>
//                 )}
//             />
//             {/* {logGroups &&
//         logGroups.map((childLogs: ILog[], groupIndex: number) => {
//           return (
//           );
//         })} */}
//             {status === 'notRunning' && <p>_</p>}
//             {showSpinner && status === 'loading' && <Spinner />}
//         </div>
//     );
// };
//# sourceMappingURL=Inner.js.map